enum CART_TYPES {
  OUTCOME = 'outcome',
  PRODUCT = 'product',
  INTAKE = 'intake',
  CITATION = 'citation',
  BOARDING = 'boarding',
}

enum CART_CHECKOUT_METHODS {
  ADOPT = 'adopt_app',
  MANUAL = 'manual',
  MOBILE = 'mobile_checkout',
}

export { CART_CHECKOUT_METHODS, CART_TYPES };
